var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-pepper"},[_c('div',{staticClass:"background",style:(_vm.backgroundStyle)},[_c('img',{style:(_vm.pepperStyle),attrs:{"src":_vm.pepperUrl,"role":"img","tabindex":"0","alt":"Pepper loader"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }